import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  Injectable,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withFetch,
  HttpBackend,
  HttpClient
} from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app-routing.module';
import { AppModule } from './app.module';
import { MyThemePresets } from '../theme';
import { environment } from '../environments/environment';
import { EnvironmentModel } from '../models/environment.model';

function msalInit(appConfig: AppConfig) {
  return () => appConfig.initConfig();
}

@Injectable({
  providedIn: 'root'
})
export class AppConfig {
  private http: HttpClient;

  constructor(httpBackend: HttpBackend) {
    this.http = new HttpClient(httpBackend);
  }

  public initConfig(): Promise<EnvironmentModel> {
    return new Promise((resolve, reject) => {
      this.http.get('config/config.json').subscribe(
        (envData: any) => {
          const jsonPath = (
            'config/environment.' +
            envData.EnvironmentSetting +
            '.json'
          ).toLowerCase();

          this.http.get(jsonPath).subscribe(
            (envConfig: any) => {
              const data = envConfig as EnvironmentModel;

              environment.environmentSetting = envData.EnvironmentSetting;
              environment.disableLogin = data.disableLogin;
              environment.production = data.production;
              environment.baseUrlApi = data.baseUrlApi;
              environment.baseUrlEventsApi = data.baseUrlEventsApi;
              environment.baseUrlClient = data.baseUrlClient;
              environment.tenant = data.tenant;
              environment.clientId = data.clientId;
              environment.acceleratorDashboardUrl =
                data.acceleratorDashboardUrl;
              environment.isProdEnvironment =
                environment.environmentSetting === 'prod';
              environment.basePartnerManagementApiUrl =
                data.basePartnerManagementApiUrl;
              environment.managementPortalUrl = data.managementPortalUrl;
              environment.spsUrl = data.spsUrl;
              environment.appInsightsInstrumentationKey =
                data.appInsightsInstrumentationKey;

              resolve(data);
            },
            error => reject(error)
          );
        },
        error => reject(error)
      );
    });
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: msalInit,
      deps: [AppConfig],
      multi: true
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom(BrowserModule, AppModule),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    providePrimeNG({
      theme: {
        preset: MyThemePresets,
        options: {
          darkModeSelector: '.my-app-dark'
        }
      }
    })
  ]
};
